import { DriverModel } from '../driverModel'

export const validateImiModel = (driverModel: DriverModel): Array<string> => {
  const validationMessages = []

  if (!driverModel.address) {
    validationMessages.push('address')
  }

  if (!driverModel.postalCode) {
    validationMessages.push('postalCode')
  }

  if (!driverModel.city) {
    validationMessages.push('city')
  }

  if (!driverModel.country) {
    validationMessages.push('country')
  }

  if (!driverModel.birthday) {
    validationMessages.push('birthday')
  }

  if (!driverModel.drivingLicenceNumber) {
    validationMessages.push('drivingLicenceNumber')
  }

  if (!driverModel.surname) {
    validationMessages.push('surname')
  }

  if (!driverModel.name) {
    validationMessages.push('name')
  }

  if (!driverModel.workingStartTime && driverModel.activeContract == null) {
    validationMessages.push('workStartTime')
  }

  if (!driverModel.driverIdCardNumber) {
    validationMessages.push('driverIdCardNumber')
  } else if (!/^[a-zA-Z0-9]+$/.test(driverModel.driverIdCardNumber)) {
    validationMessages.push('driverIdCardNumberFormat')
  }

  if (!driverModel.driverIdCardNumberIssuingCountry) {
    validationMessages.push('driverIdCardCountry')
  }

  if (driverModel.activeContract == null) {
    validationMessages.push('missingActiveContract')
  }

  return validationMessages
}
